<template>
    <div class="recharge_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="back">
                <van-icon name="arrow-left"/>
            </div>
            <div class="big_tit">{{ $t('userSet.sm') }}</div>
        </div>
        <div class="wrap_box warp1">

            <div class="card" v-show="pub === 1">
                <input class="input" type="text" v-model="postData.name" :placeholder="$t('userSet.srxm')">
                <input class="input" type="text" v-model="postData.idCard" :placeholder="$t('userSet.srsfz')">
                <input class="input" type="password" v-model="postData.pwd" :placeholder="$t('userSet.qpwd')">
            </div>
            <div v-show="pub === 2">
                <div class="card">
                    <div class="upload-card">
                        <van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024"
                                      @oversize="onOversize"
                                      :after-read="(file)=>{ afterRead(file, 'idCardHead') }"
                                      @delete="(file)=> { delFile(file,'idCardHead') }"
                                      :before-read="beforeRead"
                        >
                            <div class="upload-action">
                                <img class="upload-icon" src="@/assets/img/upload.png" alt="">
                                <div class="upload-text">{{ $t('userSet.scsfzzm') }}</div>
                            </div>
                        </van-uploader>
                    </div>
                </div>
                <div class="card">
                    <div class="upload-card">
                        <van-uploader v-model="fileList1" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024"
                                      @oversize="onOversize"
                                      :after-read="(file)=>{ afterRead(file, 'idCardSide') }"
                                      @delete="(file)=> { delFile(file,'idCardSide') }"
                                      :before-read="beforeRead"
                        >
                            <div class="upload-action">
                                <img class="upload-icon" src="@/assets/img/upload.png" alt="">
                                <div class="upload-text">{{ $t('userSet.scsfzfm') }}</div>
                            </div>
                        </van-uploader>
                    </div>
                </div>
            </div>

            <div>
                <!--        <div class="item">-->
                <!--          <div class="ari_font">{{ $t('accountUsdt.name') }}：</div>-->
                <!--          <input class="card" type="text" v-model="postData.name" :placeholder="$t('userSet.srxm')">-->
                <!--        </div>-->
                <!--        <div class="item">-->
                <!--          <div class="ari_font">{{ $t('userSet.sfz') }}：</div>-->
                <!--          <input class="card" type="text" v-model="postData.idCard" :placeholder="$t('userSet.srsfz')">-->
                <!--        </div>-->
                <!--        <div class="item">-->
                <!--          <div class="ari_font">{{ $t('userSet.sczm') }}：</div>-->
                <!--          <div class="qrcode_img">-->
                <!--            <van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024"-->
                <!--                          @oversize="onOversize"-->
                <!--                          :after-read="(file)=>{ afterRead(file, 'idCardHead') }"-->
                <!--                          @delete="(file)=> { delFile(file,'idCardHead') }"-->
                <!--                          :before-read="beforeRead"-->
                <!--            >-->
                <!--            </van-uploader>-->
                <!--          </div>-->
                <!--        </div>-->
                <!--        <div class="item">-->
                <!--          <div class="ari_font">{{ $t('userSet.scfm') }}：</div>-->
                <!--          <div class="qrcode_img">-->
                <!--            <van-uploader v-model="fileList1" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024"-->
                <!--                          @oversize="onOversize"-->
                <!--                          :after-read="(file)=>{ afterRead(file, 'idCardSide') }"-->
                <!--                          @delete="(file)=> { delFile(file,'idCardSide') }"-->
                <!--                          :before-read="beforeRead"-->
                <!--            >-->
                <!--            </van-uploader>-->
                <!--          </div>-->
                <!--        </div>-->
                <!--        <div class="item">-->
                <!--          <div class="ari_font">{{ $t('userSet.pwd') }}：</div>-->
                <!--          <input class="card" type="password" v-model="postData.pwd" :placeholder="$t('userSet.qpwd')">-->
                <!--        </div>-->

            </div>
            <van-button class="next" v-if="pub === 1" :disabled="disabled" block @click="next">{{ $t('invest.next') }}</van-button>
            <van-button class="next" v-else :disabled="disabled" block @click="submitBtn">{{ $t('account.submit') }}</van-button>
            <!--        <div class="basic_btn" @click="submitBtn">{{ $t('account.submit') }}</div>-->
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import Api from "../../interface/index";
import {
    Overlay, Uploader, Button, DropdownMenu, DropdownItem, Toast
} from 'vant';
import axios from 'axios'

Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
export default {
    name: "realName",
    data() {
        return {
            postData: {
                name: '',
                idCard: '',
                idCardHead: '',
                idCardSide: '',
                pwd: '',
            },
            fileList: [],
            fileList1: [],
            realStatus: 0,
            pub: 1,
        };
    },
    computed: {
        disabled() {
            return !this.postData.name || !this.postData.idCard
        }
    },
    created() {
        this.getUserReal()
        this.$parent.footer('user', false);
    },
    mounted() {
    },
    methods: {
        back() {
            if (this.pub === 2) {
                this.pub = 1
            } else {
                this.$router.go(-1)
            }
        },
        next() {
            this.pub = 2
        },
        getUserReal() {
            Fetch('/user/getUserReal').then(r => {
                this.postData.name = r.data.name
                this.postData.idCard = r.data.idcard
                this.postData.idCardHead = r.data.idCardHead
                this.postData.idCardSide = r.data.idCardSide
                this.realStatus = r.data.realStatus

                if (r.data.idCardHead && r.data.idCardSide) {
                    this.fileList = [{url: r.data.idCardHead}]
                    this.fileList1 = [{url: r.data.idCardSide}]
                }

            })
        },
        submitBtn() {
            if (!this.postData.name) {
                this.$notify(this.$t('userSet.srxm'));
                return;
            }
            if (!this.postData.idCard) {
                this.$notify(this.$t('userSet.srsfz'));
                return;
            }
            // if (this.postData.idCard.length !== 18) {
            //     this.$notify(this.$t('userSet.gs'));
            //     return;
            // }
            if (!this.postData.idCardHead) {
                this.$notify(this.$t('userSet.scsfzzm'));
                return;
            }
            if (!this.postData.idCardSide) {
                this.$notify(this.$t('userSet.scsfzfm'));
                return;
            }
            if (!this.postData.pwd) {
                this.$notify(this.$t('userSet.qpwd'));
                return;
            }
            Fetch('/user/realName_submit', this.postData).then(r => {
                this.$notify(r.info);
                this.$router.replace('/realNameStatus')
            })
        },
        onOversize(file) {
            this.$toast(this.$t('account.within2megabytes'));
        },
        beforeRead(file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
                this.$toast(this.$t('account.supportPicture'));
                return false;
            }
            return true;
        },
        afterRead(file, key) {
            let formData = new FormData();
            formData.append('language', this.$i18n.locale || "en_us");
            formData.append('file', file.file);
            formData.append('id', this.$router.history.current.params.id);
            formData.append('token', localStorage.getItem('token'));
            Toast.loading({
                forbidClick: true,
                duration: 20000
            });
            axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
                Toast.clear();
                if (r.data.code === 1) {
                    this.postData[key] = r.data.data
                    // this.bank.img = r.data.data;
                } else {
                    if (r.data.info) {
                        this.$toast(r.data.info);
                    } else {
                        this.$toast(this.$t('account.uploadFail'));
                    }
                }
            });
        },
        delFile(file, key) {
            this.postData[key] = ''
        }

    }
};
</script>

<style lang="less" scoped>
.dis {
  pointer-events: none;
}

.next {
  height: 2.96875rem;
  background: linear-gradient(0deg, #AD8667 0%, #DFC5B3 100%);
  color: #241e1f;
  border-radius: 0.40625rem;
  margin: 0 auto;
  margin-top: 2.59375rem;
  font-size: .84375rem;
  text-align: center;
  line-height: 2.96875rem;
  border: none;
}

.upload-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.upload-icon {
  width: 40px;
  height: 40px;
}

.upload-text {
  margin-top: .5rem;
  font-size: .8rem;
  color: rgb(239, 216, 196) !important;
}

.active {

}

.red_top_bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgb(35, 29, 29) !important;
  color: rgb(239, 216, 196) !important;

  .back_left {
    color: rgb(239, 216, 196) !important;
  }

  .big_tit {
    color: rgb(239, 216, 196) !important;
  }
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-uploader__wrapper {
  width: 100%;
  height: 100%;
}

/deep/ .van-uploader__preview {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}

/deep/ .van-uploader__preview-image {
  width: 100%;
  height: 100%;
}

/deep/ .van-uploader__input-wrapper {
  width: 100%;
  height: 100%;
}

/deep/ .van-button--primary {
  background-color: transparent;
  border: none;
  width: 100%;
  height: 100%;
}

/deep/ .van-uploader {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}


.rela {
  position: relative;
  z-index: 11;
}

.upload-card {
  width: 100%;
  height: 10rem;
  background: #251E1F;
  margin: 0 auto;
}

.card {
  width: 100%;
  background: #251E1F;
  border: 1px solid #917E70;
  border-radius: 0.59375rem;
  margin: 0 auto;
  margin-top: 1.25rem;
  padding: 14px;
}

.recharge_wrap {
  height: 100vh;
}

.input {
  width: 100%;
  height: 2.96875rem;
  background: #4B4241;
  border-radius: 0.21875rem;
  margin-top: 1.34375rem;
  color: #f5e7db;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: flex;
  align-items: center;
}

.warp1 {
  padding: 14px;
  height: calc(100vh - 44px);
  margin-top: 44px;
  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;
  overflow-y: scroll;

  .item {
    min-height: 50px;
    padding: 8px 16px;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #ECECEC;

    &:last-child {
      border-bottom: none;
    }

    .card {
      width: 100%;
    }

    input {
      line-height: 14px;
    }
  }
}

.ari_font {
  word-break: keep-all;
  white-space: nowrap;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, .8);
  line-height: 20px;
  margin-right: 5px;
}

.basic_btn {
  margin: 75px auto 0 auto;
}

.qrcode {
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: center;

  div {
    color: #999;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .upload {
    width: 100%;
    height: 100%;
  }

  .qrcode_img {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    background: linear-gradient(to left, #999, #999) left top no-repeat,
    linear-gradient(to bottom, #999, #999) left top no-repeat,
    linear-gradient(to left, #999, #999) right top no-repeat,
    linear-gradient(to bottom, #999, #999) right top no-repeat,
    linear-gradient(to left, #999, #999) left bottom no-repeat,
    linear-gradient(to bottom, #999, #999) left bottom no-repeat,
    linear-gradient(to left, #999, #999) right bottom no-repeat,
    linear-gradient(to left, #999, #999) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;

    span {
      line-height: 220px;
    }

    img {
      width: 240px;
      height: 240px;
      position: relative;
      top: -255px;
    }
  }
}
</style>
